import { css } from "emotion";

export const container = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: AvenirLTStd45Book;
    color: rgb(122, 122, 122);
`;

export const successIcon = css`
    width: 90px;
    height: 90px;
    font-size: 50px;
    margin: 80px 0 20px 0;
    fill: #338b2b;
`;

export const header = css`
    margin-bottom: 80px;
`;